import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-[#1a0d2e] border-t border-[#3a2456]" data-id="element-59">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-60">
        <div className="mb-10" data-id="element-61">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-62">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-63" />
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-64">
          <div className="min-w-[600px] max-w-3xl mx-auto" data-id="element-65">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4 items-end" data-id="element-66">
              <div data-id="element-67"></div>
              <div className="font-bold text-slate-400 uppercase text-sm tracking-wider text-center" data-id="element-68">
                🍷 MEGAPACK VINOTECA LISTO™
              </div>
              <div className="font-bold text-slate-200 uppercase text-sm tracking-wider text-center flex items-center justify-center gap-1" data-id="element-69">
                ⭐ MEGAPACK VINOTECA LISTO™ + NIVEL MAESTRO
              </div>
            </div>

            <div className="space-y-2" data-id="element-70">
              <div className="grid grid-cols-3 gap-4 bg-[#0d0716]/60 rounded-xl p-4 items-center border border-[#3a2456]" data-id="element-71">
                <div className="text-slate-400 font-medium text-sm" data-id="element-72">
                  Contenido
                </div>
                <div className="text-white font-medium text-center" data-id="element-73">
                  6 tomos + 4 bonos
                </div>
                <div className="text-slate-200 font-bold text-center" data-id="element-74">
                  6 tomos + 4 bonos + Nivel Maestro
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-[#0d0716]/60 rounded-xl p-4 items-center border border-[#3a2456]" data-id="element-75">
                <div className="text-slate-400 font-medium text-sm" data-id="element-76">Precio</div>
                <div className="text-white font-bold text-center" data-id="element-77">
                  $19.990 ARS
                </div>
                <div className="text-slate-200 font-bold text-center text-lg" data-id="element-78">
                  $27.990 ARS
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-transparent p-4 items-center" data-id="element-79">
                <div data-id="element-80"></div>
                <div className="text-center" data-id="element-81">
                  <a href="https://www.centralpack.shop/cart/53782188359998:1" target="_blank" rel="noopener noreferrer" data-id="element-82">
                    <Button size="sm" variant="outline" className="w-full text-xs" data-id="element-83">
                      🔥 QUIERO MI MEGAPACK
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-84">
                  <a href="https://www.centralpack.shop/cart/53782192292158:1" target="_blank" rel="noopener noreferrer" data-id="element-85">
                    <Button size="sm" variant="premium" className="w-full text-xs" data-id="element-86">
                      ⚡ QUIERO EL MEGAPACK + NIVEL MAESTRO
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-slate-300 font-medium" data-id="element-87">
          <div className="flex items-center gap-1.5" data-id="element-88">
            <Lock className="w-4 h-4 text-slate-300" data-id="element-89" />
            <span data-id="element-90">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-91">
            <Zap className="w-4 h-4 text-slate-300" data-id="element-92" />
            <span data-id="element-93">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-94">
            <Shield className="w-4 h-4 text-slate-300" data-id="element-95" />
            <span data-id="element-96">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-97">
            <CreditCard className="w-4 h-4 text-slate-300" data-id="element-98" />
            <span data-id="element-99">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}